import React, { useEffect, useRef, useState } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';

// Renders an iframe at a fixed 1280×720 canvas and scales it to fit its container.
// qrUrl/qrLogo: renders QR overlay *inside* the canvas so it scales with content
// and is correctly positioned regardless of container width on desktop.
export default function ScaledIframe({ src, title, qrUrl, qrLogo }) {
  const containerRef = useRef();
  const [scale, setScale] = useState(1);
  const isMobile = useMediaQuery('(max-width:899px)');

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const ro = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;
      if (width > 0 && height > 0) {
        setScale(Math.min(1, Math.min(width / 1280, height / 720)));
      }
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const scaledW = 1280 * scale;
  const scaledH = 720  * scale;

  return (
    <Box
      ref={containerRef}
      sx={{ width: '100%', height: '100%', overflow: 'hidden', position: 'relative', bgcolor: '#000' }}
    >
      <Box sx={{
        width: 1280, height: 720,
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        position: 'absolute',
        top:  `calc(50% - ${scaledH / 2}px)`,
        left: `calc(50% - ${scaledW / 2}px)`,
      }}>
        <iframe
          src={src}
          title={title || 'Presentation'}
          style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
        />
        {qrUrl && !isMobile && (
          <Box sx={{
            position: 'absolute', bottom: 24, right: 24, zIndex: 10,
            bgcolor: 'rgba(0,0,0,0.52)', borderRadius: '8px', p: '6px',
            backdropFilter: 'blur(4px)', display: 'inline-flex',
            pointerEvents: 'none',
          }}>
            <QRCodeSVG
              value={qrUrl}
              size={88}
              level="H"
              bgColor="transparent"
              fgColor="rgba(255,255,255,0.90)"
              imageSettings={qrLogo ? { src: qrLogo, width: 22, height: 22, excavate: true } : undefined}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}
